// General Imports
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Component Pages
// import { LandingComponent } from './website/website-landing/landing.component';
import { NotFoundComponent } from './website/website-not-found/not-found.component';
import { WebsiteLandingV2Component } from './website/website-landing-v2/website-landing-v2.component';

const routes: Routes = [
  { path: 'company', loadChildren: () => import('./company/company.module').then(m => m.CompanyModule) },
  { path: 'newsandevents', loadChildren: () => import('./newsandevents/newsandevents.module').then(m => m.NewsandeventsModule) },
  { path: 'solutions', loadChildren: () => import('./solutions/solutions.module').then(m => m.SolutionsModule) },
  { path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule) },
  { path: 'productfamily', loadChildren: () => import('./productfamily/productfamily.module').then(m => m.ProductfamilyModule) },
  { path: 'productcategory', loadChildren: () => import('./productcategory/productcategory.module').then(m => m.ProductcategoryModule) },
  { path: 'products', loadChildren: () => import('./products/products.module').then(m => m.ProductsModule) },
  { path: '', component: WebsiteLandingV2Component, pathMatch: 'full' },
  { path: '', loadChildren: () => import('./main/main.module').then(m => m.MainModule) },

  { path: 'di3000_app_download/:id', pathMatch: 'prefix', redirectTo: 'products/di3000'},

  { path: 'login', pathMatch: 'full', redirectTo: 'company/login'},
  { path: 'register', pathMatch: 'full', redirectTo: 'company/register'},
  { path: 'forgotpassword', pathMatch: 'full', redirectTo: 'company/forgotpassword'},
  { path: 'c', pathMatch: 'full', redirectTo: 'company/form'},


  { path: 'mttplus', pathMatch: 'full', redirectTo: 'products/mttplusseries'},
  { path: 'productfamily/mttseries', pathMatch: 'full', redirectTo: 'products/mttplusseries'},
  { path: 'productfamily/mttplusseries', pathMatch: 'full', redirectTo: 'products/mttplusseries'},
  { path: 'multiprotocolanalyzer', pathMatch: 'full', redirectTo: 'products/mpaseries'},
  { path: 'productfamily/mpaseries', pathMatch: 'full', redirectTo: 'products/mpaseries'},
  { path: 'productfamily/fiberizer', pathMatch: 'full', redirectTo: 'products/fiberizer'},


  { path: 'wifi', pathMatch: 'full', redirectTo: 'solutions/wifi-testing'},
  { path: 'solutions/docsis3140', pathMatch: 'full', redirectTo: 'solutions/docsis31'},
  { path: 'docsis3140', pathMatch: 'full', redirectTo: 'solutions/docsis31'},
  { path: 'docsis31', pathMatch: 'full', redirectTo: 'solutions/docsis31'},
  { path: 'solution/400g-testing-the-future-of-communications', pathMatch: 'full', redirectTo: 'solutions/800g-400g-testing-the-future-of-communications'},
  { path: '400g-testing-the-future-of-communications', pathMatch: 'full', redirectTo: 'solutions/800g-400g-testing-the-future-of-communications'},

  { path: 'support/registerproduct', pathMatch: 'full', redirectTo: 'support/productregistration'},
  { path: 'registerproduct', pathMatch: 'full', redirectTo: 'support/productregistration'},

  { path: 'markets/fiberoptics', pathMatch: 'full', redirectTo: 'productcategory/fiberoptics'},


  { path: 'vxhelper/boot-up-pin-code-help', pathMatch: 'full', redirectTo: 'boot-up-pin-code-help'},
  { path: 'vxhelper/touchscreen-protectivefilm-instructions', pathMatch: 'full', redirectTo: 'touchscreen-protectivefilm-instructions'},
  { path: 'apps/php', pathMatch: 'full', redirectTo: 'apps'},
  { path: 'app', pathMatch: 'full', redirectTo: 'apps'},
  { path: 'vesion', pathMatch: 'full', redirectTo: 'server/vesion'},
  { path: 'products/vesion', pathMatch: 'full', redirectTo: 'server/vesion'},
  { path: 'products/r-server', pathMatch: 'full', redirectTo: 'server/rserver'},
  // Other
  { path: '', pathMatch: 'full', redirectTo: '/' },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(){
  }
}
